/* Ausgelagert aus layout/theme.liquid (Plan 14, Schritt 4).
   Nur im Template 'product' geladen, mit defer. */

/* Mobile Galerie-CTA: klont a.mc-sizes__cta-btn unter die Galerie (< 1024px). */
(function(){
  function insertMobileGalleryCTA() {
    if (window.innerWidth > 1023) return;
    if (document.querySelector('.mc-gallery-cta-mobile')) return;

    var origBtn = document.querySelector('a.mc-sizes__cta-btn');
    if (!origBtn) return;

    var mediaWrapper = document.querySelector('.product__media-wrapper, media-gallery');
    if (!mediaWrapper) return;

    var clone = origBtn.cloneNode(true);
    clone.classList.add('mc-gallery-cta-mobile');
    mediaWrapper.insertAdjacentElement('afterend', clone);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(insertMobileGalleryCTA, 200);
    });
  } else {
    setTimeout(insertMobileGalleryCTA, 200);
  }
})();

/* Warenkorb-Icon im ATC-Button, falls buy-buttons.liquid es nicht schon gesetzt hat (data-mc-icon). */
(function(){
  function injectPDPCartIcon() {
    var btn = document.querySelector('product-form:not(.sticky-atc-product-form) .product-form__submit');
    if (!btn || btn.dataset.mcIcon) return;
    btn.dataset.mcIcon = '1';
    var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('width','20');svg.setAttribute('height','20');
    svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');
    svg.setAttribute('stroke','#ffffff');svg.setAttribute('stroke-width','1.8');
    svg.setAttribute('stroke-linecap','round');svg.setAttribute('stroke-linejoin','round');
    svg.style.flexShrink='0';svg.style.pointerEvents='none';
    svg.innerHTML='<path d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>';
    btn.insertBefore(svg, btn.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(injectPDPCartIcon, 300); });
  } else {
    setTimeout(injectPDPCartIcon, 300);
  }
})();
